import {MdCalendarToday, MdPeople, MdStore} from 'react-icons/md'
import dayjs from 'dayjs'

import {ReservationLabel} from '../Label'
import {useCreateReservationContext} from '../ReservationContext'

export default function Resume() {
  const {storeOptions, partySize, date, isWaitingList} = useCreateReservationContext()
  return (
    <div className="space-y-2">
      <ReservationLabel className="flex space-x-2 items-center">
        <MdCalendarToday className="h-4 w-4" />
        <span className="flex-1">
          {date
            ? dayjs(date).tz(storeOptions.timezone).format('LLL')
            : isWaitingList
            ? 'Lista de espera'
            : 'Selecciona una fecha'}
        </span>
      </ReservationLabel>
      <ReservationLabel className="flex space-x-2 items-center">
        <MdPeople className="h-4 w-4" />
        <span className="flex-1">{partySize} personas</span>
      </ReservationLabel>
      <ReservationLabel className="flex space-x-2 items-center">
        <MdStore className="h-4 w-4" />
        <span className="flex-1">
          {storeOptions.address.addressLine1}, {storeOptions.address.addressLine2}
        </span>
      </ReservationLabel>
    </div>
  )
}
